<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  }
}
</script>
<style lang="less" scoped>
  /*#app{*/
  /*  width: 100vw;*/
  /*  min-width:1140px;*/
  /*  min-height: 400px;*/
  /*}*/
</style>

<style  lang="less">
  .el-loading-spinner .circular{
    width: 42px;
    height: 42px;
    animation: loading-rotate 2s linear infinite;
    display: none;
  }
  .el-loading-spinner{
    /* 图片替换为你自定义的即可 */
    background: url(./assets/images/loading.gif) no-repeat;
    background-size: 200px 200px;
    width: 200px !important;
    height: 200px;
    position: relative;
    top: 50%;
    left: 50%;
    margin-top: -100px !important;
    margin-left: -100px;
  }

  /* 列表导出：提示文案放到 GIF 下方，避免被遮住；全程可见 */
  .q7-export-loading .el-loading-spinner {
    height: auto !important;
    min-height: 200px;
    padding-bottom: 8px;
    overflow: visible;
  }
  .q7-export-loading .el-loading-text {
    position: relative;
    top: auto;
    margin: 208px 0 0;
    width: 320px;
    max-width: 80vw;
    margin-left: -60px;
    color: #fff !important;
    font-size: 15px !important;
    line-height: 1.55;
    white-space: normal;
    word-break: break-word;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  }
  .q7-export-notify {
    z-index: 4000 !important;
  }
</style>
